import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ModalFooter, Button } from 'reactstrap';
import { I18N, GlobalContext, I18NContext, EBModal } from 'commons';
import { connect } from 'react-redux';
import * as currentUserActions from 'state/actions/currentUserActions';

const TimeZoneSection = ({ timeZone, onChange, disabled, timeZones, getProfileInit, isTimeZoneExposed, isTimeZoneEditable, isTimeZoneMandatory }) => {
  const { lang, account: { id: contactId } } = useContext(GlobalContext);
  const [showEmptyOption, setShowEmptyOption] = useState(!timeZone || timeZone === null);
  const [selectedTimeZone, setSelectedTimeZone] = useState(timeZone === null ? '' : timeZone);
  const randomId = Math.floor(Math.random() * 100);

  useEffect(() => {
    if (timeZone === null) {
      setSelectedTimeZone('');
      setShowEmptyOption(true);
    } else {
      setSelectedTimeZone(timeZone);
      setShowEmptyOption(false);
    }
  }, [timeZone]);

  useEffect(() => {
    if (getProfileInit) {
      getProfileInit(contactId);
    }
  }, [lang]);

  if (!isTimeZoneExposed) {
    return null;
  }

  return (
    <div className="form-group row">
      <div className="col-md-12">
        <label id={`timeZoneLabel-${randomId}`} htmlFor={`timeZone-${randomId}`}>
          <I18N>contact.path.device.time.frame.quiet.time.timezone</I18N>
          {isTimeZoneMandatory && (
              <>
                <span aria-hidden="true" className="required-star">*</span>
                <span className="sr-only"><I18N>information.label.required</I18N></span>
              </>
          )}
        </label>
        <select
            className="form-control"
            onChange={(e) => {
              const {currentTarget: {value}} = e;
              if (value) {
                setShowEmptyOption(false);
              }
              onChange(e);
            }}
            name="timeZone"
            id={`timeZone-${randomId}`}
            value={selectedTimeZone}
            disabled={disabled || !isTimeZoneEditable}
            eb-test="ssp_myprofile_timezone"
        >
          {(showEmptyOption || timeZone === null) && <I18N tag="option" value="">ssp.select.null.text</I18N>}
          {_.map(timeZones, ({displayLabel, id}) => (
              <option selected={id === selectedTimeZone} value={id} key={id} id={id}>
                {displayLabel.includes(':') ? displayLabel.replace(':', ' ') : displayLabel}
              </option>
          ))}
        </select>
      </div>
    </div>
  );
};
TimeZoneSection.propTypes = {
  timeZone: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  getProfileInit: PropTypes.func.isRequired,
  timeZones: PropTypes.arrayOf(PropTypes.shape()),
  isTimeZoneExposed: PropTypes.bool.isRequired,
  isTimeZoneEditable: PropTypes.bool.isRequired,
  isTimeZoneMandatory: PropTypes.bool.isRequired,
};

TimeZoneSection.defaultProps = {
  onChange: () => { },
  timeZone: '',
  disabled: false,
  timeZones: [],
};

const mapDispatchToProps = dispatch => ({
  getProfileInit: (contactId) => dispatch(currentUserActions.getProfileInit.action({ contactId })),
});

export default connect(
  null,
  mapDispatchToProps,
)(TimeZoneSection);


export const useTimeZoneModal = (isOpen, timeZone, onChange, onSave, disabled, timeZones, isTimeZoneExposed, isTimeZoneEditable) => {
  const i18n = useContext(I18NContext);

  const [isModalOpen, updateIsModalOpen] = useState(isOpen || false);
  const [currentTimeZone, updateCurrentTimeZone] = useState(timeZone);

  const modal = (
    <EBModal
      className="setup-timezone-modal"
      title={i18n.get('home.profile.timezone.setup.dialog.title')}
      type="confirm"
      isOpen={isModalOpen}
      toggleModal={() => {
        updateIsModalOpen(false);
      }}
      showFooter={false}
    >
      <TimeZoneSection
        onChange={(e) => {
          const { currentTarget: { value } } = e;
          updateCurrentTimeZone(value);
          if (onChange) {
            onChange(e);
          }
        }}
        disabled={disabled}
        timeZone={currentTimeZone}
        timeZones={timeZones}
        isTimeZoneExposed={isTimeZoneExposed}
        isTimeZoneEditable={isTimeZoneEditable}
      />
      <ModalFooter>
        <Button
          color="secondary"
          onClick={() => {
            updateCurrentTimeZone('');
            updateIsModalOpen(false);
          }}
        >
          <I18N>global.dialog.button.cancel</I18N>
        </Button>
        <Button
          color="primary"
          onClick={() => {
            onSave(currentTimeZone);
            updateIsModalOpen(false);
          }}
        >
          <I18N>button.save</I18N>
        </Button>
      </ModalFooter>
    </EBModal>
  );

  return [modal, updateIsModalOpen];
};
